var _g, _g2, _path, _g3, _path2, _g4, _path3, _g5, _path4, _path5, _path6, _g6, _path7, _path8, _path9, _path10, _path11, _g7, _path12, _path13, _path14, _g8, _g9, _g10, _g11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShapesIphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 289,
    viewBox: "0 0 142 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_218_9786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.772 1H24.938C12.261 1 1.984 11.277 1.984 23.954v241.248c0 12.677 10.277 22.954 22.954 22.954h92.834c12.677 0 22.953-10.277 22.953-22.954V23.954C140.725 11.277 130.449 1 117.772 1",
    fill: "#393348"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_218_9786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 57.082c0-.18.147-.328.328-.328h.655v10.49h-.655A.33.33 0 0 1 1 66.916z",
    fill: "#B4B0B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 57.082c0-.18.147-.328.328-.328h.655v10.49h-.655A.33.33 0 0 1 1 66.916z",
    fill: "url(#paint0_linear_218_9786)",
    fillOpacity: 0.8
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 57.082c0-.18.147-.328.328-.328h.655v10.49h-.655A.33.33 0 0 1 1 66.916z",
    stroke: "#AFABAE",
    strokeWidth: 0.164
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_218_9786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 77.893c0-.18.147-.328.328-.328h.655V98.85h-.655A.33.33 0 0 1 1 98.52z",
    fill: "#B4B0B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 77.893c0-.18.147-.328.328-.328h.655V98.85h-.655A.33.33 0 0 1 1 98.52z",
    fill: "url(#paint1_linear_218_9786)",
    fillOpacity: 0.8
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 77.893c0-.18.147-.328.328-.328h.655V98.85h-.655A.33.33 0 0 1 1 98.52z",
    stroke: "#AFABAE",
    strokeWidth: 0.164
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_218_9786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 105.503c0-.181.147-.328.328-.328h.655v21.284h-.655a.33.33 0 0 1-.328-.328z",
    fill: "#B4B0B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 105.503c0-.181.147-.328.328-.328h.655v21.284h-.655a.33.33 0 0 1-.328-.328z",
    fill: "url(#paint2_linear_218_9786)",
    fillOpacity: 0.8
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 105.503c0-.181.147-.328.328-.328h.655v21.284h-.655a.33.33 0 0 1-.328-.328z",
    stroke: "#AFABAE",
    strokeWidth: 0.164
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.872 31.344H1.984v1.966h1.888zm136.849 0h-1.887v1.966h1.887zM111.885 2.887V1h-1.966v1.887zm28.828 255.521v-1.887h-1.878v1.887zm-136.84 0v-1.887H1.907v1.887zm29.375 29.748v-1.887h-1.966v1.887z",
    fill: "#4C4254",
    style: {
      mixBlendMode: "overlay"
    }
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_218_9786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.707 92.788a.33.33 0 0 0-.328-.328h-.655v33.998h.655a.327.327 0 0 0 .328-.327z",
    fill: "#B4B0B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.707 92.788a.33.33 0 0 0-.328-.328h-.655v33.998h.655a.327.327 0 0 0 .328-.327z",
    fill: "url(#paint3_linear_218_9786)",
    fillOpacity: 0.8
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.707 92.788a.33.33 0 0 0-.328-.328h-.655v33.998h.655a.327.327 0 0 0 .328-.327z",
    stroke: "#AFABAE",
    strokeWidth: 0.164
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_218_9786",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 136,
    height: 283
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.601 2.769H25.107c-11.728 0-21.236 9.508-21.236 21.236v239.73c0 11.728 9.508 21.236 21.236 21.236h92.494c11.728 0 21.236-9.508 21.236-21.236V24.005c0-11.728-9.508-21.236-21.236-21.236",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_218_9786)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.601 2.769H25.107c-11.728 0-21.236 9.508-21.236 21.236v239.73c0 11.728 9.508 21.236 21.236 21.236h92.494c11.728 0 21.236-9.508 21.236-21.236V24.005c0-11.728-9.508-21.236-21.236-21.236",
    fill: "#000"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_218_9786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.69 2.769h27.326l-.275.727a.71.71 0 0 1-.662.458H58.626a.71.71 0 0 1-.662-.458z",
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_218_9786",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 127,
    height: 274
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.339 7.016H25.368c-9.527 0-17.25 7.724-17.25 17.25v239.206c0 9.528 7.723 17.251 17.25 17.251h91.971c9.527 0 17.25-7.723 17.25-17.251V24.267c0-9.527-7.723-17.25-17.25-17.25",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_218_9786)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M117.339 7.016H25.368c-9.527 0-17.25 7.724-17.25 17.25v239.206c0 9.528 7.723 17.251 17.25 17.251h91.971c9.527 0 17.25-7.723 17.25-17.251V24.267c0-9.527-7.723-17.25-17.25-17.25",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_218_9786",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 127,
    height: 274
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.588 7.021H8.118v273.696h126.47z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_218_9786)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M134.588 7.021H8.118v273.696h126.47z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_218_9786",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 127,
    height: 275
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M134.588 7.021H8.118v274.597h126.47z",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_218_9786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.823 276.64H49.41a.841.841 0 0 0 0 1.683h43.413a.842.842 0 0 0 0-1.683",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 87H22a8 8 0 0 0-8 8v99a8 8 0 0 0 8 8h99a8 8 0 0 0 8-8V95a8 8 0 0 0-8-8",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117 99H26v91h91z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117 99H26v91h91z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.518 136.917h3.033v-3.034h-1.517a1.52 1.52 0 0 0-1.516 1.517m3.032 1.517h-3.033v3.033h1.517a1.52 1.52 0 0 0 1.517-1.517m-.001 4.55h-1.516a1.515 1.515 0 0 0-1.517 1.517v1.517h1.517a1.52 1.52 0 0 0 1.517-1.517m-3.033 13.65h3.033v-3.033h-1.517a1.514 1.514 0 0 0-1.516 1.516m3.032 1.517h-3.032v3.033h3.033zm3.034-3.033h-3.033v3.033h3.033zm0 3.033h-3.033v3.033h1.516a1.52 1.52 0 0 0 1.517-1.516m0-28.817h3.033v-3.033h-1.516a1.52 1.52 0 0 0-1.517 1.516m3.033 1.517h-3.033v3.033h3.033zm0 3.033h-3.033v3.034h3.033zm-3.033 9.1h3.033v-3.033h-1.516a1.52 1.52 0 0 0-1.517 1.517m3.033 1.516h-3.033v3.034H35.1a1.52 1.52 0 0 0 1.517-1.517m-3.033 10.617h3.033v-3.034h-1.516a1.515 1.515 0 0 0-1.517 1.517m3.033-25.784h3.034v-3.033h-1.517a1.52 1.52 0 0 0-1.517 1.517",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.65 127.816h-3.033v3.034h3.034zm0 3.034h-3.033v3.033h3.034zm0 3.033h-3.033v3.034h3.034zm-3.033 18.2h3.034v-3.033h-1.517a1.52 1.52 0 0 0-1.517 1.517m3.033 1.516h-3.033v3.034h3.034zm0 3.034h-3.033v3.033h3.034zm0 3.033h-3.033v3.033h1.517a1.52 1.52 0 0 0 1.516-1.516",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.684 127.816H39.65v3.034h1.517a1.52 1.52 0 0 0 1.517-1.517m0 4.55H39.65v3.034h1.517a1.515 1.515 0 0 0 1.517-1.517m0 10.617h-1.517a1.514 1.514 0 0 0-1.517 1.516v1.517h1.517a1.52 1.52 0 0 0 1.517-1.517m0 4.55H39.65v3.034h1.517a1.52 1.52 0 0 0 1.517-1.517m-3.034 10.617h3.034v-3.034h-1.517a1.515 1.515 0 0 0-1.517 1.517m3.034-34.884h3.033v-3.033H44.2a1.52 1.52 0 0 0-1.516 1.517m0 25.783h3.033v-3.033H44.2a1.52 1.52 0 0 0-1.516 1.517m3.033 10.616h-3.033v3.033h3.033zm3.033-36.4h-3.033v3.034h3.033zm0 6.067h-1.517a1.52 1.52 0 0 0-1.516 1.517v1.516h1.516a1.514 1.514 0 0 0 1.517-1.516m-3.033 7.583h3.033v-3.034h-1.517a1.515 1.515 0 0 0-1.516 1.517m3.033 4.55h-1.517a1.515 1.515 0 0 0-1.516 1.517v1.517h1.516a1.52 1.52 0 0 0 1.517-1.517m0 4.55h-3.033v3.033h3.033zm-3.033 9.1h3.033v-3.033h-1.517a1.514 1.514 0 0 0-1.516 1.516m3.033 4.55h-3.033v3.033h3.033zm3.033-36.4H48.75v3.034h3.033z",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.783 127.816H48.75v3.034h3.033zm-3.033 9.101h3.033v-3.034h-1.516a1.52 1.52 0 0 0-1.517 1.517m3.035 1.517h-3.033v3.033h1.517a1.52 1.52 0 0 0 1.516-1.517M48.75 149.05h3.033v-3.034h-1.516a1.515 1.515 0 0 0-1.517 1.517m3.033 1.517H48.75v3.033h3.033zm0 6.067H48.75v3.033h3.033zm0 6.066H48.75v3.033h3.033zm.002-54.6h3.034v-3.033h-1.517a1.52 1.52 0 0 0-1.517 1.517m3.034 1.516h-3.034v3.034h3.034zm-.001 12.134h-1.516a1.52 1.52 0 0 0-1.517 1.516v1.517h1.517a1.52 1.52 0 0 0 1.516-1.517m.001 7.583h-3.034v3.034h3.034zm0 6.067h-3.034v3.034h3.034zm-3.034 12.134h3.034v-3.034h-1.517a1.52 1.52 0 0 0-1.517 1.517m3.034 1.517h-3.034v3.033h3.034zm0 3.033h-3.034v3.033h3.034zm0 3.033h-3.034v3.034h3.034zm0 3.034h-3.034v3.033h3.034zm0 3.033h-3.034v3.033h3.034zm-.001 3.033h-3.033v3.033h1.517a1.514 1.514 0 0 0 1.516-1.516m-3.033 7.583h3.034v-3.033h-1.517a1.52 1.52 0 0 0-1.517 1.517m3.034 1.516h-3.034v3.034h3.034zm-3.034 9.1h3.034v-3.033h-1.517a1.52 1.52 0 0 0-1.517 1.517m6.067-77.35h-1.517a1.514 1.514 0 0 0-1.517 1.516v1.517h1.517a1.52 1.52 0 0 0 1.517-1.517",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.852 106.583h-3.034v3.034h3.034zm-3.034 9.1h3.034v-3.033h-1.517a1.52 1.52 0 0 0-1.517 1.516m3.034 1.517h-3.034v3.033h1.517a1.514 1.514 0 0 0 1.517-1.516m-3.034 10.616h3.034v-3.033h-1.517a1.52 1.52 0 0 0-1.517 1.517m3.034 1.516h-3.034v3.034h3.034zm0 3.034h-3.034v3.033h3.034zm0 3.033h-3.034v3.034h3.034zm0 9.1h-3.034v3.034h3.034zm0 3.034h-3.034v3.033h3.034zm0 3.033h-3.034v3.033h1.517a1.52 1.52 0 0 0 1.517-1.517m0 4.551h-3.034v3.033h3.034zm0 12.133h-3.034v3.033h3.034zm0 3.033h-3.034v3.034h1.517a1.515 1.515 0 0 0 1.517-1.517m0 4.55h-3.034v3.033h3.034zm0 3.033h-3.034v3.034h3.034zm0 3.034h-3.034v3.033h3.034zm0 3.033h-3.034v3.033h3.034zm3.033-78.867h-3.033v3.034h3.033zm0 3.034h-3.033v3.033h3.033z",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.885 112.65H57.85v3.033h1.517a1.52 1.52 0 0 0 1.517-1.516m-3.032 7.583h3.033v-3.033h-1.517a1.514 1.514 0 0 0-1.516 1.516m3.033 1.517h-3.033v3.033h3.033zm0 6.066H57.85v3.034h1.517a1.52 1.52 0 0 0 1.517-1.517m.001 4.55H57.85v3.034h1.517a1.515 1.515 0 0 0 1.517-1.517m-3.032 19.717h3.033v-3.034h-1.517a1.515 1.515 0 0 0-1.516 1.517m3.033 1.517h-3.033v3.033h3.033zm0 3.033h-3.033v3.033h3.033zm0 6.067h-1.517a1.52 1.52 0 0 0-1.517 1.516v1.517h1.517a1.52 1.52 0 0 0 1.517-1.517m0 19.717H57.85v3.033h1.517a1.52 1.52 0 0 0 1.517-1.517m3.034-83.416h-1.517a1.52 1.52 0 0 0-1.516 1.516v1.517H62.4a1.52 1.52 0 0 0 1.517-1.517m.001 4.551h-3.033v3.033h3.033zm0 12.133h-3.033v3.033h3.033zm0 3.033h-3.033v3.034h3.033zm-3.033 9.1h3.033v-3.033h-1.517a1.52 1.52 0 0 0-1.516 1.517m0 7.583h3.033v-3.034h-1.517a1.515 1.515 0 0 0-1.516 1.517m3.033 1.517h-3.033v3.033h3.033zm0 6.067h-1.517a1.514 1.514 0 0 0-1.516 1.516v1.517H62.4a1.52 1.52 0 0 0 1.517-1.517m.001 7.584h-3.033v3.033h3.033zm0 3.033h-3.033v3.033h3.033zm0 3.033h-3.033v3.033h3.033zm-3.033 9.1h3.033v-3.033h-1.517a1.52 1.52 0 0 0-1.516 1.517m3.033 1.516h-3.033v3.034H62.4a1.515 1.515 0 0 0 1.517-1.517m-3.032 7.583h3.033v-3.033h-1.517a1.52 1.52 0 0 0-1.516 1.517",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.951 109.617h-3.033v3.033h1.517a1.52 1.52 0 0 0 1.516-1.517m-3.033 7.584h3.033v-3.034h-1.516a1.515 1.515 0 0 0-1.517 1.517m3.033 1.517h-3.033v3.033h3.033zm0 3.033h-3.033v3.033h3.033zm0 3.033h-3.033v3.034h3.033z",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.951 127.816h-3.033v3.034h3.033zm0 3.034h-3.033v3.033h1.517a1.514 1.514 0 0 0 1.516-1.516m0 7.583h-3.033v3.033h3.033zm0 3.033h-3.033v3.034h3.033zm0 15.167h-3.033v3.033h3.033zm0 3.033h-3.033v3.033h3.033zm0 3.034h-3.033v3.033h3.033zm0 3.033h-3.033v3.033h3.033zm0 9.1h-3.033v3.033h3.033zm0 3.033h-3.033v3.034h3.033zm0 3.034h-3.033v3.033h1.517a1.52 1.52 0 0 0 1.516-1.517m3.033-83.416h-1.516a1.514 1.514 0 0 0-1.517 1.516v1.517h1.517a1.52 1.52 0 0 0 1.516-1.517m0 4.55h-1.516a1.515 1.515 0 0 0-1.517 1.517v1.517h1.517a1.52 1.52 0 0 0 1.516-1.517m0 7.583h-3.033v3.033h1.517a1.514 1.514 0 0 0 1.516-1.516m0 10.616h-3.033v3.034h1.517a1.52 1.52 0 0 0 1.516-1.517m-3.033 10.617h3.034v-3.034h-1.517a1.515 1.515 0 0 0-1.517 1.517",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.985 139.95H66.95v3.033h3.034zm-.001 3.033h-3.033v3.034h1.517a1.52 1.52 0 0 0 1.516-1.517m-3.033 7.583h3.034v-3.033h-1.517a1.52 1.52 0 0 0-1.517 1.517m3.034 1.516H66.95v3.034h3.034zm0 3.034H66.95v3.033h3.034zm0 3.033H66.95v3.033h3.034zm-.001 3.033h-3.033v3.033h1.517a1.514 1.514 0 0 0 1.516-1.516m.001 4.55H66.95v3.033h3.034zm0 9.1H66.95v3.033h3.034zm-3.034 12.133h3.034v-3.033h-1.517a1.52 1.52 0 0 0-1.517 1.517m6.067-83.417H71.5a1.52 1.52 0 0 0-1.517 1.516v1.517H71.5a1.52 1.52 0 0 0 1.517-1.517m.001 13.651H71.5a1.52 1.52 0 0 0-1.517 1.516v1.517H71.5a1.52 1.52 0 0 0 1.517-1.517m.001 10.617H71.5a1.52 1.52 0 0 0-1.517 1.517v1.516H71.5a1.514 1.514 0 0 0 1.517-1.516m.001 4.55h-3.034v3.033h3.034z",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.018 139.95h-3.034v3.033h3.034zm-3.034 9.1h3.034v-3.034H71.5a1.515 1.515 0 0 0-1.517 1.517m3.035 1.517h-3.034v3.033h1.517a1.52 1.52 0 0 0 1.517-1.517m0 7.584h-3.034v3.033h1.517a1.52 1.52 0 0 0 1.517-1.516m0 7.583h-3.034v3.033h3.034zm0 9.1h-3.034v3.033h3.034zm0 3.033h-3.034v3.034h3.034zm0 3.034h-3.034v3.033h3.034zm0 3.033h-3.034v3.033h1.517a1.52 1.52 0 0 0 1.517-1.517m3.032-86.449h-1.516a1.514 1.514 0 0 0-1.517 1.516v1.517h1.517a1.52 1.52 0 0 0 1.517-1.517m-3.033 10.617h3.033v-3.033h-1.517a1.514 1.514 0 0 0-1.516 1.516m3.032 1.517h-3.032v3.033h3.033zm-3.032 12.133h3.033v-3.033h-1.517a1.52 1.52 0 0 0-1.516 1.517m3.032 1.516h-3.033v3.034h1.517a1.515 1.515 0 0 0 1.517-1.517m-.001 13.65h-3.032v3.033h3.033z",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.05 146.017h-3.033v3.033h1.517a1.52 1.52 0 0 0 1.517-1.517m-3.033 7.584h3.033v-3.034h-1.517a1.515 1.515 0 0 0-1.516 1.517m3.032 7.583h-1.516a1.52 1.52 0 0 0-1.517 1.517v1.516h1.517a1.514 1.514 0 0 0 1.517-1.516m-.001 4.55h-3.032v3.033h3.033zm0 9.1h-3.033v3.033h1.517a1.514 1.514 0 0 0 1.517-1.516m-.001 4.55h-3.033v3.033h1.517a1.52 1.52 0 0 0 1.517-1.517m-.001-74.316h3.034v-3.034h-1.517a1.515 1.515 0 0 0-1.516 1.517m3.033 1.517h-3.033v3.033h3.033zm0 3.033h-3.033v3.033h3.033zm0 6.067h-1.517a1.52 1.52 0 0 0-1.516 1.516v1.517h1.516a1.52 1.52 0 0 0 1.517-1.517m-3.034 13.65h3.034v-3.033h-1.517a1.52 1.52 0 0 0-1.516 1.517m-.001 7.583h3.034v-3.034h-1.517a1.515 1.515 0 0 0-1.516 1.517m3.033 1.517h-3.033v3.033h3.033zm0 3.033h-3.033v3.034h1.516a1.52 1.52 0 0 0 1.517-1.517m0 7.583h-3.033v3.034h1.516a1.52 1.52 0 0 0 1.517-1.517m-3.034 13.65h3.034v-3.033h-1.517a1.514 1.514 0 0 0-1.516 1.516m3.033 1.517h-3.033v3.033h3.033zm0-60.667h3.033v-3.033h-1.516a1.52 1.52 0 0 0-1.517 1.517m3.033 7.583h-3.033v3.033h3.033zm0 12.133H80.6a1.52 1.52 0 0 0-1.516 1.517v1.517H80.6a1.515 1.515 0 0 0 1.517-1.517m0 4.55h-3.033v3.033h3.033zm0 3.033h-3.033v3.034h3.033zm0 3.034h-3.033v3.033H80.6a1.52 1.52 0 0 0 1.517-1.517m-3.033 22.75h3.033v-3.033h-1.516a1.52 1.52 0 0 0-1.517 1.516m3.033 1.517h-3.033v3.033h3.033zm0 3.034h-3.033v3.033h3.033zm0 3.033h-3.033v3.033H80.6a1.514 1.514 0 0 0 1.517-1.516m-3.033 10.616h3.033v-3.033h-1.516a1.52 1.52 0 0 0-1.517 1.517m3.033 1.516h-3.033v3.034H80.6a1.515 1.515 0 0 0 1.517-1.517m-3.033 7.583h3.033v-3.033h-1.516a1.52 1.52 0 0 0-1.517 1.517m3.033-83.417h3.033v-3.034h-1.516a1.515 1.515 0 0 0-1.517 1.517m3.033 1.517h-3.033v3.033h1.517a1.52 1.52 0 0 0 1.516-1.517m0 7.584h-3.033v3.033h3.033zm0 3.033h-3.033v3.033h3.033zm0 3.034h-3.033v3.033h3.033zm0 3.033h-3.033v3.033h3.033zm-3.033 24.267h3.033v-3.034h-1.516a1.52 1.52 0 0 0-1.517 1.517m3.033 1.517h-3.033v3.033h1.517a1.52 1.52 0 0 0 1.516-1.517m-3.033 10.617h3.033v-3.033h-1.516a1.514 1.514 0 0 0-1.517 1.516m3.033 1.517h-3.033v3.033h1.517a1.52 1.52 0 0 0 1.516-1.516m-3.033 16.683h3.033v-3.033h-1.516a1.52 1.52 0 0 0-1.517 1.516m3.033 10.617h-3.033v3.033h3.033zm0-72.8h3.034v-3.033h-1.517a1.514 1.514 0 0 0-1.517 1.516m3.034 4.55H85.15v3.033h1.517a1.514 1.514 0 0 0 1.517-1.516m0 4.55H85.15v3.033h3.034zm-3.034 9.1h3.034v-3.033h-1.517a1.52 1.52 0 0 0-1.517 1.516m3.034 1.517H85.15v3.033h1.517a1.514 1.514 0 0 0 1.517-1.516m-3.034 10.616h3.034v-3.033h-1.517a1.52 1.52 0 0 0-1.517 1.517m0 25.783h3.034v-3.033h-1.517a1.514 1.514 0 0 0-1.517 1.516m3.034 1.517H85.15v3.033h3.034zm0 3.033H85.15v3.034h3.034z",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.184 173.316H85.15v3.034h3.034zm0 3.034H85.15v3.033h3.034zm0 9.1H85.15v3.033h1.517a1.52 1.52 0 0 0 1.517-1.517m0-83.416h3.033v-3.034H89.7a1.515 1.515 0 0 0-1.516 1.517m3.033 1.517h-3.033v3.033h3.033zm0 3.033h-3.033v3.034h3.033zm0 3.034h-3.034v3.033H89.7a1.52 1.52 0 0 0 1.517-1.517m-3.033 10.617h3.033v-3.033H89.7a1.514 1.514 0 0 0-1.516 1.516m3.033 1.517h-3.034v3.033H89.7a1.514 1.514 0 0 0 1.517-1.516m0 4.549h-3.033v3.034h3.033zm-3.033 12.134h3.033v-3.034H89.7a1.515 1.515 0 0 0-1.516 1.517m3.033 1.517h-3.034v3.033H89.7a1.52 1.52 0 0 0 1.517-1.517m-3.033 7.584h3.033v-3.034H89.7a1.515 1.515 0 0 0-1.516 1.517m3.033 1.517h-3.033v3.033h3.033zm-3.033 9.1h3.033v-3.033H89.7a1.514 1.514 0 0 0-1.516 1.516m3.033 1.517h-3.033v3.033h3.033zm0 3.033h-3.033v3.033h3.033zm0 3.034h-3.033v3.033h3.033zm0 3.033h-3.033v3.033h3.033z",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.217 170.283h-3.033v3.034h3.033z",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.217 173.316h-3.033v3.034h3.033zm0 3.034h-3.033v3.033h3.033zm0 6.067H89.7a1.514 1.514 0 0 0-1.517 1.516v1.517H89.7a1.52 1.52 0 0 0 1.517-1.517m0-56.117h3.033v-3.033h-1.516a1.52 1.52 0 0 0-1.517 1.517m3.033 1.516h-3.033v3.034h3.033zm0 3.034h-3.033v3.033h1.516a1.514 1.514 0 0 0 1.517-1.516m0 13.65h-3.033v3.033h3.033zm0 3.033h-3.033v3.033h1.516a1.52 1.52 0 0 0 1.517-1.517m0 10.617h-3.033v3.033h3.033zm0 12.133h-3.033v3.034h3.033zm0 3.034h-3.033v3.033h3.033zm-3.033 12.133h3.033v-3.033h-1.516a1.52 1.52 0 0 0-1.517 1.517m6.068-59.151h-3.033v3.034h1.516a1.517 1.517 0 0 0 1.517-1.517m0 4.55h-1.517a1.515 1.515 0 0 0-1.516 1.517v1.517h1.516a1.514 1.514 0 0 0 1.517-1.517m-3.035 10.617h3.033v-3.034h-1.516a1.52 1.52 0 0 0-1.517 1.517m3.033 1.517H94.25v3.033h3.033zm-3.033 9.1h3.033v-3.034h-1.516a1.515 1.515 0 0 0-1.517 1.517m3.033 1.517H94.25v3.033h3.033zm0 6.066H94.25v3.033h3.033zm.002 6.067h-1.517a1.52 1.52 0 0 0-1.516 1.517v1.516h1.516a1.513 1.513 0 0 0 1.517-1.516m-.002 4.549H94.25v3.034h3.033zm0 3.034H94.25v3.033h3.033zm.002 3.033h-3.033v3.034h1.516a1.514 1.514 0 0 0 1.517-1.517m-.002 4.55H94.25v3.033h3.033zm3.035-54.6h-1.516a1.52 1.52 0 0 0-1.517 1.517v1.516h1.517a1.513 1.513 0 0 0 1.516-1.516m-3.033 7.583h3.033v-3.034h-1.516a1.52 1.52 0 0 0-1.517 1.517m3.033 1.517h-3.033v3.033h1.517a1.517 1.517 0 0 0 1.516-1.517m0 4.551h-3.033v3.033h3.033zm0 9.1h-3.033v3.033h3.033zm0 3.033h-3.033v3.033h3.033zm0 3.033h-3.033v3.033h3.033zm0 12.133h-3.033v3.034h3.033z",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.318 176.35h-3.033v3.033h1.517a1.513 1.513 0 0 0 1.516-1.516m-3.033 7.583h3.033v-3.034h-1.516a1.52 1.52 0 0 0-1.517 1.517m3.033 1.517h-3.033v3.033h1.517a1.517 1.517 0 0 0 1.516-1.517m3.034-40.949h-3.034v3.033h3.034zm0 3.033h-3.034v3.033h3.034zm0 3.033h-3.034v3.034h3.034zm0 3.034h-3.034v3.033h3.034zm0 3.033h-3.034v3.033h3.034zm0 3.033h-3.034v3.033h3.034zm0 3.034h-3.034v3.033h3.034zm0 3.033h-3.034v3.033h3.034zm0 3.033h-3.034v3.034h3.034z",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.352 173.316h-3.034v3.034h3.034zm3.033-24.266h-3.033v3.033h3.033zm0 3.033h-3.033v3.034h3.033zm0 3.034h-3.033v3.033h3.033zm0 3.033h-3.033v3.033h3.033zm0 3.033h-3.034v3.033h1.517a1.517 1.517 0 0 0 1.517-1.516m0 7.583h-3.033v3.034h3.033z",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.385 173.316h-3.033v3.034h3.033zm0 3.034h-3.033v3.033h3.033zm-3.033 9.1h3.033v-3.034h-1.517a1.514 1.514 0 0 0-1.516 1.517m3.033-56.117h3.033v-3.033h-1.517a1.517 1.517 0 0 0-1.516 1.517m0 7.583h3.033v-3.033h-1.517a1.517 1.517 0 0 0-1.516 1.517m3.033 16.683h-3.033v3.033h3.033zm-3.033 18.2h3.033v-3.033h-1.517a1.513 1.513 0 0 0-1.516 1.516m3.033 7.583h-3.033v3.034h3.033zm0 3.034h-3.033v3.033h3.033zm0 3.033h-3.033v3.034h3.033zm0 3.034h-3.033v3.033h3.033zm0 3.033h-3.033v3.033h1.516a1.52 1.52 0 0 0 1.517-1.517",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.451 124.783h-3.033v3.034h1.517a1.514 1.514 0 0 0 1.516-1.517m0 4.55h-3.033v3.033h3.033zm0 3.033h-3.033v3.034h3.033zm-3.033 12.134h3.033v-3.034h-1.516a1.52 1.52 0 0 0-1.517 1.517m3.033 1.517h-3.033v3.033h3.033zm0 3.033h-3.033v3.033h3.033zm0 9.1h-1.516a1.517 1.517 0 0 0-1.517 1.517v1.516h1.517a1.517 1.517 0 0 0 1.516-1.516m0 4.55h-3.033v3.033h1.517a1.517 1.517 0 0 0 1.516-1.517m0 10.617h-3.033v3.033h3.033zm3.033-42.467h-3.033v3.034h1.517a1.514 1.514 0 0 0 1.516-1.517m0 4.55h-1.516a1.52 1.52 0 0 0-1.517 1.516v1.517h1.517a1.517 1.517 0 0 0 1.516-1.517m0 7.584h-3.033v3.033h1.517a1.517 1.517 0 0 0 1.516-1.517m0 10.617h-1.516a1.52 1.52 0 0 0-1.517 1.517v1.516h1.517a1.513 1.513 0 0 0 1.516-1.516m-3.033 7.583h3.034v-3.033h-1.517a1.52 1.52 0 0 0-1.517 1.517m3.034 1.516h-3.034v3.034h3.034z",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.485 173.316h-3.034v3.034h3.034zm-.001 3.034h-3.033v3.033h1.517a1.513 1.513 0 0 0 1.516-1.516m0 7.583h-1.516a1.52 1.52 0 0 0-1.517 1.516v1.517h1.517a1.517 1.517 0 0 0 1.516-1.517m-77.351-86.449a10.617 10.617 0 1 0 .03 0zm0 3.033a7.584 7.584 0 1 1-.03 0z",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.584 109.617h3.033v-3.034h-1.516a1.515 1.515 0 0 0-1.517 1.517m3.033 1.517h-3.033v3.033h3.033zm0 3.033h-3.033v3.034h3.033z",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.65 106.583h-3.033v3.034h3.034zm0 3.034h-3.033v3.033h3.034zm0 3.033h-3.033v3.034h3.034z",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.684 106.583H39.65v3.034h3.034zm0 3.034H39.65v3.033h3.034zm0 3.033H39.65v3.034h1.517a1.52 1.52 0 0 0 1.517-1.517m72.798-3.034a10.618 10.618 0 0 0-18.126-7.489 10.618 10.618 0 0 0 7.502 18.121 10.615 10.615 0 0 0 10.624-10.601zm-3.033 0a7.584 7.584 0 1 1 0-.03z",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.316 109.617h3.034v-3.034h-1.517c-.402 0-.788.16-1.072.445-.285.284-.445.67-.445 1.072m3.034 1.517h-3.034v3.033h3.034zm0 3.033h-3.034v3.034h3.034z",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.383 106.583h-3.033v3.034h3.033zm0 3.034h-3.033v3.033h3.033zm0 3.033h-3.033v3.034h3.033zm3.033-6.067h-3.033v3.034h3.033zm0 3.034h-3.033v3.033h3.033zm0 3.033h-3.033v3.034h1.516a1.516 1.516 0 0 0 1.517-1.517m-81.898 63.7a10.617 10.617 0 1 0 0-.031zm3.033 0a7.583 7.583 0 1 1 0 .03z",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.584 176.35h3.033v-3.033h-1.516a1.52 1.52 0 0 0-1.517 1.516m3.033 1.517h-3.033v3.033h3.033zm0 3.034h-3.033v3.033h3.033z",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.65 173.317h-3.033v3.033h3.034zm0 3.033h-3.033v3.033h3.034zm0 3.034h-3.033v3.033h3.034z",
    fill: "#2D9425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.684 173.317H39.65v3.033h3.034zm0 3.033H39.65v3.033h3.034zm0 3.034H39.65v3.033h1.517a1.52 1.52 0 0 0 1.517-1.517",
    fill: "#2D9425"
  })))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M85.392 10.555H57.077a6.017 6.017 0 1 0 0 12.034h28.315a6.017 6.017 0 1 0 0-12.034",
    fill: "#000"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4 14.517a2.056 2.056 0 1 0 0 4.112 2.056 2.056 0 0 0 0-4.113",
    fill: "url(#paint4_linear_218_9786)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4 17.903a1.33 1.33 0 1 0 0-2.661 1.33 1.33 0 0 0 0 2.66",
    fill: "url(#paint5_radial_218_9786)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_218_9786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.28 15.484a.92.92 0 0 0-.684.319 1.16 1.16 0 0 0-.284.77c0 .288.102.565.284.77a.92.92 0 0 0 .684.318z",
    fill: "url(#paint6_linear_218_9786)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_218_9786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.16 16.452a.363.363 0 1 0 0-.726.363.363 0 0 0 0 .726",
    fill: "#50326D"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_218_9786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.523 17.662a.92.92 0 0 0 .684-.319 1.16 1.16 0 0 0 .283-.77 1.16 1.16 0 0 0-.283-.77.92.92 0 0 0-.684-.318z",
    fill: "url(#paint7_linear_218_9786)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_218_9786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.642 17.42a.363.363 0 1 0 0-.726.363.363 0 0 0 0 .726",
    fill: "url(#paint8_linear_218_9786)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_218_9786",
    x: 1.657,
    y: 0.672,
    width: 139.396,
    height: 287.811,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.164
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.733333 0 0 0 0 0.721569 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_218_9786"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_218_9786",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.384766 0 0 0 0 0.331597 0 0 0 0 0.416667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_218_9786"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_218_9786",
    x: 1,
    y: 56.427,
    width: 1.311,
    height: 10.818,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.328,
    dy: -0.328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.164
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_218_9786"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_218_9786",
    x: 1,
    y: 77.238,
    width: 1.311,
    height: 21.611,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.328,
    dy: -0.328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.164
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_218_9786"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_218_9786",
    x: 1,
    y: 104.847,
    width: 1.311,
    height: 21.612,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.328,
    dy: -0.328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.164
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_218_9786"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_218_9786",
    x: 140.724,
    y: 92.132,
    width: 1.311,
    height: 34.326,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.328,
    dy: -0.328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.164
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_218_9786"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_218_9786",
    x: 57.69,
    y: 2.297,
    width: 27.327,
    height: 1.657,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.472
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.236
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.220833 0 0 0 0 0.220833 0 0 0 0 0.220833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_218_9786"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_218_9786",
    x: 83.985,
    y: 15.156,
    width: 1.623,
    height: 2.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.164,
    result: "effect1_foregroundBlur_218_9786"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_218_9786",
    x: 83.647,
    y: 14.576,
    width: 3.025,
    height: 3.025,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.575,
    result: "effect1_foregroundBlur_218_9786"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_218_9786",
    x: 85.195,
    y: 15.157,
    width: 1.623,
    height: 2.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.164,
    result: "effect1_foregroundBlur_218_9786"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_218_9786",
    x: 84.896,
    y: 16.311,
    width: 1.492,
    height: 1.492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.192,
    result: "effect1_foregroundBlur_218_9786"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_218_9786",
    x1: 1.492,
    y1: 56.754,
    x2: 1.492,
    y2: 67.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#C0B7BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#1E1423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#605565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#605968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#1E1423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC9CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_218_9786",
    x1: 1.492,
    y1: 77.565,
    x2: 1.492,
    y2: 98.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#C0B7BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#1E1423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#605565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#605968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#1E1423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC9CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_218_9786",
    x1: 1.492,
    y1: 105.175,
    x2: 1.492,
    y2: 126.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#C0B7BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#1E1423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#605565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#605968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#1E1423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC9CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_218_9786",
    x1: 141.215,
    y1: 92.46,
    x2: 141.215,
    y2: 126.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#C0B7BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#1E1423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#605565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#605968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#1E1423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC9CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_218_9786",
    x1: 87.094,
    y1: 17.661,
    x2: 83.829,
    y2: 15.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_218_9786",
    x1: 84.554,
    y1: 15.726,
    x2: 85.159,
    y2: 17.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20569B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#061127"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_218_9786",
    x1: 86.248,
    y1: 17.42,
    x2: 85.644,
    y2: 15.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D6495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#061127"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_218_9786",
    x1: 86.126,
    y1: 17.299,
    x2: 85.642,
    y2: 16.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3291AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3291AF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_218_9786",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.08856 .84666 -.85291 1.0966 85.4 16.451)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#152457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapesIphone);
export default __webpack_public_path__ + "static/media/shapes-iphone.50a0f2791c528172dfe68ba430108b59.svg";
export { ForwardRef as ReactComponent };